import React from "react";
import { error } from "../../components/common/helpers/toastify";
import { Link } from "react-router-dom";
import "./NewSocialModal.scss";
import { useTranslation } from "react-i18next";

export const NewSocialModal = (props) => {
  const { t } = useTranslation();
  const { shareUrl, shareloader } = props;

  return (
    <>
      <div
        className="modal fade social-modal new-style-social-modal"
        id="newSocialModal"
        tabIndex="-1"
        aria-labelledby="socialLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <p className="modal-title-share">{t("Share with")}</p>
              <button
                type="button"
                className=""
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 15L10 10M10 10L5 5M10 10L15 5M10 10L5 15"
                    stroke="#A4A4A4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
            <div className="modal-body">
              <div className="social-modal-ct">
                {!shareloader || shareUrl ? (
                  <div className="social-modal-ct-icons">
                    <Link
                      to={
                        shareUrl
                          ? `https://twitter.com/intent/tweet?text=${shareUrl}%23.Y2o2bSK7RiE.twitter&related=`
                          : () => error(t("error"))
                      }
                      target="_blank"
                      className="social-modal-ct-icons-diamond-wrap twitter"
                    >
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M12.0372 17.402L0.608144 30.4475H5.67108L14.4192 20.4355L22.1277 30.4496L32 30.3957L19.4834 13.8443L30.1648 1.60905L25.1832 1.55334L17.1148 10.7485L10.2118 1.56836L0 1.55728L12.0372 17.402ZM26.021 27.4446L23.4661 27.4366L5.91307 4.45666H8.66127L26.021 27.4446Z"
                          fill="black"
                        />
                      </svg>

                      <label className="social-modal-ct-icons-diamond-wrap-label">
                        {t("twitter")}
                      </label>
                    </Link>

                    <Link
                      to={
                        shareUrl
                          ? `https://www.facebook.com/login.php?skip_api_login=1&api_key=140586622674265&signed_next=1&next=${shareUrl}%2523.Y2oyRZYtNeM.facebook%26client_id%3D140586622674265%26ret%3Dlogin&cancel_url=https%3A%2F%2Fs7.addthis.com%2Fstatic%2Fthankyou.html%3Ferror_code%3D4201%26error_message%3DUser%2Bcanceled%2Bthe%2BDialog%2Bflow%23_%3D_&display=popup&locale=en_GB`
                          : () => error(t("error"))
                      }
                      target="_blank"
                      className="social-modal-ct-icons-diamond-wrap facebook"
                    >
                      <svg
                        viewBox="0 0 16 16"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        width="32"
                        height="32"
                      >
                        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                        <g
                          id="SVGRepo_tracerCarrier"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></g>
                        <g id="SVGRepo_iconCarrier">
                          <path
                            fill="#1877F2"
                            d="M15 8a7 7 0 00-7-7 7 7 0 00-1.094 13.915v-4.892H5.13V8h1.777V6.458c0-1.754 1.045-2.724 2.644-2.724.766 0 1.567.137 1.567.137v1.723h-.883c-.87 0-1.14.54-1.14 1.093V8h1.941l-.31 2.023H9.094v4.892A7.001 7.001 0 0015 8z"
                          ></path>
                          <path
                            fill="#ffffff"
                            d="M10.725 10.023L11.035 8H9.094V6.687c0-.553.27-1.093 1.14-1.093h.883V3.87s-.801-.137-1.567-.137c-1.6 0-2.644.97-2.644 2.724V8H5.13v2.023h1.777v4.892a7.037 7.037 0 002.188 0v-4.892h1.63z"
                          ></path>
                        </g>
                      </svg>
                      <label className="social-modal-ct-icons-diamond-wrap-label">
                        {t("facebook")}
                      </label>
                    </Link>

                    <Link
                      to={
                        shareUrl
                          ? `https://mail.google.com/mail/u/0/?fs=1&to&su=${shareUrl}%23.Y2o7fryfP4w.gmail&ui=2&tf=cm`
                          : () => error(t("error"))
                      }
                      target="_blank"
                      className="social-modal-ct-icons-diamond-wrap gmail"
                    >
                      <svg
                        width="33"
                        height="32"
                        viewBox="0 0 33 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_10234_72897)">
                          <path
                            d="M2.80682 28.0061H7.89773V15.6424L0.625 10.1879V25.8242C0.625 27.0315 1.60318 28.0061 2.80682 28.0061Z"
                            fill="#4285F4"
                          />
                          <path
                            d="M25.3525 28.0061H30.4434C31.6507 28.0061 32.6253 27.0279 32.6253 25.8242V10.1879L25.3525 15.6424"
                            fill="#34A853"
                          />
                          <path
                            d="M25.3525 6.18801V15.6426L32.6253 10.188V7.27892C32.6253 4.58073 29.5453 3.04255 27.3889 4.66073"
                            fill="#FBBC04"
                          />
                          <path
                            d="M7.89746 15.6424V6.18787L16.6247 12.7333L25.352 6.18787V15.6424L16.6247 22.1879"
                            fill="#EA4335"
                          />
                          <path
                            d="M0.625 7.27892V10.188L7.89773 15.6426V6.18801L5.86136 4.66073C3.70136 3.04255 0.625 4.58074 0.625 7.27892Z"
                            fill="#C5221F"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_10234_72897">
                            <rect
                              width="32"
                              height="32"
                              fill="white"
                              transform="translate(0.625)"
                            />
                          </clipPath>
                        </defs>
                      </svg>

                      <label className="social-modal-ct-icons-diamond-wrap-label">
                        {t("gmail")}
                      </label>
                    </Link>
                    <Link
                      to={
                        shareUrl
                          ? `https://www.facebook.com/login.php?api_key=140586622674265&skip_api_login=1&display=page&cancel_url=${shareUrl}%2523.Y2o8Zl0O_H0.messenger%26from_login%3D1`
                          : () => error(t("error"))
                      }
                      target="_blank"
                      className="social-modal-ct-icons-diamond-wrap messanger"
                    >
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16 0C6.988 0 0 6.604 0 15.52C0 20.184 1.912 24.216 5.024 27C5.284 27.232 5.444 27.56 5.452 27.912L5.54 30.76C5.54641 30.9696 5.60419 31.1743 5.70827 31.3563C5.81234 31.5383 5.95953 31.692 6.13689 31.8037C6.31425 31.9155 6.51635 31.982 6.72544 31.9974C6.93452 32.0128 7.14418 31.9766 7.336 31.892L10.512 30.492C10.78 30.372 11.084 30.352 11.368 30.428C12.828 30.828 14.38 31.044 16 31.044C25.012 31.044 32 24.44 32 15.524C32 6.608 25.012 0 16 0Z"
                          fill="url(#paint0_radial_10234_31664)"
                        />
                        <path
                          d="M6.39153 20.06L11.0915 12.604C11.2683 12.3233 11.5014 12.0823 11.7761 11.8962C12.0507 11.7101 12.361 11.583 12.6872 11.5229C13.0135 11.4627 13.3487 11.4709 13.6716 11.5468C13.9946 11.6228 14.2983 11.7648 14.5635 11.964L18.3035 14.768C18.4705 14.893 18.6736 14.9603 18.8822 14.9596C19.0908 14.9588 19.2934 14.8902 19.4595 14.764L24.5075 10.932C25.1795 10.42 26.0595 11.228 25.6115 11.944L20.9075 19.396C20.7307 19.6768 20.4976 19.9178 20.223 20.1039C19.9483 20.2899 19.6381 20.4171 19.3118 20.4772C18.9856 20.5374 18.6504 20.5292 18.3274 20.4533C18.0045 20.3773 17.7008 20.2353 17.4355 20.036L13.6955 17.232C13.5286 17.107 13.3254 17.0398 13.1169 17.0405C12.9083 17.0413 12.7056 17.1099 12.5395 17.236L7.49153 21.068C6.81953 21.58 5.93953 20.776 6.39153 20.06Z"
                          fill="white"
                        />
                        <defs>
                          <radialGradient
                            id="paint0_radial_10234_31664"
                            cx="0"
                            cy="0"
                            r="1"
                            gradientUnits="userSpaceOnUse"
                            gradientTransform="translate(5.36 32) scale(35.2 35.2)"
                          >
                            <stop stopColor="#0099FF" />
                            <stop offset="0.6" stopColor="#A033FF" />
                            <stop offset="0.9" stopColor="#FF5280" />
                            <stop offset="1" stopColor="#FF7061" />
                          </radialGradient>
                        </defs>
                      </svg>

                      <label className="social-modal-ct-icons-diamond-wrap-label">
                        {t("messenger")}
                      </label>
                    </Link>

                    <Link
                      to={
                        shareUrl
                          ? `https://telegram.me/share/url?url=${shareUrl}%23.Y2o993ySRos.telegram&text=MongoDB+Create+Database+Username+Password+to+Secure+Data+%7C+ObjectRocket`
                          : () => error(t("error"))
                      }
                      target="_blank"
                      className="social-modal-ct-icons-diamond-wrap telegram"
                    >
                      <svg
                        width="30"
                        height="25"
                        viewBox="0 0 30 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M2.34952 10.466C10.2236 7.03533 15.4742 4.77364 18.1014 3.6809C25.6025 0.560916 27.1611 0.0189416 28.1771 0.00104531C28.4005 -0.00289079 28.9001 0.0524848 29.2237 0.31508C29.497 0.536811 29.5722 0.836337 29.6081 1.04656C29.6441 1.25679 29.6889 1.73568 29.6533 2.10988C29.2468 6.3809 27.488 16.7455 26.5931 21.5292C26.2145 23.5533 25.469 24.232 24.7472 24.2984C23.1787 24.4427 21.9876 23.2618 20.4684 22.2659C18.0911 20.7076 16.7481 19.7375 14.4406 18.2168C11.7738 16.4594 13.5025 15.4936 15.0223 13.915C15.4201 13.5019 22.3311 7.21575 22.4649 6.64549C22.4816 6.57417 22.4971 6.30832 22.3392 6.16795C22.1813 6.02757 21.9482 6.07557 21.78 6.11375C21.5415 6.16787 17.7438 8.67804 10.3868 13.6443C9.30884 14.3845 8.33245 14.7451 7.45763 14.7262C6.49322 14.7054 4.63808 14.1809 3.25897 13.7326C1.56744 13.1828 0.223047 12.8921 0.340114 11.9583C0.40109 11.4719 1.07089 10.9744 2.34952 10.466Z"
                          fill="url(#paint0_linear_10234_26906)"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_10234_26906"
                            x1="1467"
                            y1="0.000854492"
                            x2="1467"
                            y2="2412.93"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#2AABEE" />
                            <stop offset="1" stopColor="#229ED9" />
                          </linearGradient>
                        </defs>
                      </svg>

                      <label className="social-modal-ct-icons-diamond-wrap-label">
                        {t("telegram")}
                      </label>
                    </Link>

                    <Link
                      to={
                        shareUrl
                          ? `https://api.addthis.com/oexchange/0.8/forward/wechat/offer?url=${shareUrl}%23.Y2o-fiOKjSE.wechat&title=MongoDB+Create+Database+Username+Password+to+Secure+Data+%7C+ObjectRocket&pco=binv-300&pubid=ra-5d530f84697c9404&sid=636a02e115165088`
                          : () => error(t("error"))
                      }
                      target="_blank"
                      className="social-modal-ct-icons-diamond-wrap wechat"
                    >
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20.4999 11.5169C20.9545 11.5169 21.3984 11.5547 21.8364 11.6087C21.0446 8.13121 17.3921 5.50085 13.0001 5.50085C8.02899 5.50085 4 8.86822 4 13.0209C4 15.4151 5.34708 17.5393 7.4365 18.9137L6.24996 21.2931L9.4823 19.9049C10.1754 20.1517 10.8957 20.355 11.665 20.4496C11.5599 19.9907 11.5001 19.5202 11.5001 19.0373C11.5001 14.8905 15.5364 11.5169 20.4999 11.5169ZM16.0002 8.88466C16.6213 8.88466 17.125 9.38997 17.125 10.0128C17.125 10.6359 16.6213 11.1408 16.0002 11.1408C15.3787 11.1408 14.8751 10.6359 14.8751 10.0128C14.8751 9.38991 15.3787 8.88466 16.0002 8.88466ZM10 11.1408C9.37879 11.1408 8.87505 10.6359 8.87505 10.0128C8.87505 9.38997 9.37884 8.88466 10 8.88466C10.6212 8.88466 11.1251 9.38997 11.1251 10.0128C11.125 10.6359 10.6212 11.1408 10 11.1408Z"
                          fill="#51C332"
                        />
                        <path
                          d="M28 19.0372C28 15.7146 24.6412 13.0209 20.4999 13.0209C16.3584 13.0209 13.0001 15.7146 13.0001 19.0372C13.0001 22.3596 16.3584 25.0533 20.4999 25.0533C21.181 25.0533 21.8288 24.9571 22.4574 24.8204L26.5 26.5573L25.1019 23.7555C26.854 22.6543 28 20.9609 28 19.0372ZM18.25 18.6612C17.6288 18.6612 17.125 18.1561 17.125 17.5329C17.125 16.91 17.6288 16.4051 18.25 16.4051C18.8714 16.4051 19.3749 16.9102 19.3749 17.5329C19.3749 18.1561 18.8713 18.6612 18.25 18.6612ZM22.7499 18.6612C22.1284 18.6612 21.625 18.1561 21.625 17.5329C21.625 16.91 22.1284 16.4051 22.7499 16.4051C23.3714 16.4051 23.875 16.9102 23.875 17.5329C23.875 18.1561 23.3714 18.6612 22.7499 18.6612Z"
                          fill="#51C332"
                        />
                      </svg>

                      <label className="social-modal-ct-icons-diamond-wrap-label">
                        {t("wechat")}
                      </label>
                    </Link>

                    <Link
                      to={
                        shareUrl
                          ? `https://api.whatsapp.com/send?text=${shareUrl}%23.Y2owVm2N5OA.whatsapp`
                          : () => error(t("error"))
                      }
                      target="_blank"
                      className="social-modal-ct-icons-diamond-wrap whatsapp"
                    >
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4 28.0009L5.687 21.8379C4.646 20.0339 4.099 17.9889 4.1 15.8919C4.103 9.33585 9.438 4.00085 15.993 4.00085C19.174 4.00185 22.16 5.24085 24.406 7.48885C26.651 9.73685 27.887 12.7249 27.886 15.9029C27.883 22.4599 22.548 27.7949 15.993 27.7949C14.003 27.7939 12.042 27.2949 10.305 26.3469L4 28.0009ZM10.597 24.1939C12.273 25.1889 13.873 25.7849 15.989 25.7859C21.437 25.7859 25.875 21.3519 25.878 15.9009C25.88 10.4389 21.463 6.01085 15.997 6.00885C10.545 6.00885 6.11 10.4429 6.108 15.8929C6.107 18.1179 6.759 19.7839 7.854 21.5269L6.855 25.1749L10.597 24.1939ZM21.984 18.7299C21.91 18.6059 21.712 18.5319 21.414 18.3829C21.117 18.2339 19.656 17.5149 19.383 17.4159C19.111 17.3169 18.913 17.2669 18.714 17.5649C18.516 17.8619 17.946 18.5319 17.773 18.7299C17.6 18.9279 17.426 18.9529 17.129 18.8039C16.832 18.6549 15.874 18.3419 14.739 17.3289C13.856 16.5409 13.259 15.5679 13.086 15.2699C12.913 14.9729 13.068 14.8119 13.216 14.6639C13.35 14.5309 13.513 14.3169 13.662 14.1429C13.813 13.9709 13.862 13.8469 13.962 13.6479C14.061 13.4499 14.012 13.2759 13.937 13.1269C13.862 12.9789 13.268 11.5159 13.021 10.9209C12.779 10.3419 12.534 10.4199 12.352 10.4109L11.782 10.4009C11.584 10.4009 11.262 10.4749 10.99 10.7729C10.718 11.0709 9.95 11.7889 9.95 13.2519C9.95 14.7149 11.015 16.1279 11.163 16.3259C11.312 16.5239 13.258 19.5259 16.239 20.8129C16.948 21.1189 17.502 21.3019 17.933 21.4389C18.645 21.6649 19.293 21.6329 19.805 21.5569C20.376 21.4719 21.563 20.8379 21.811 20.1439C22.059 19.4489 22.059 18.8539 21.984 18.7299Z"
                          fill="#25D366"
                        />
                      </svg>

                      <label className="social-modal-ct-icons-diamond-wrap-label">
                        {t("whatsapp")}
                      </label>
                    </Link>
                    <Link
                      to={
                        shareUrl
                          ? `https://login.live.com/login.srf?wa=wsignin1.0&rpsnv=13&ct=1667907319&rver=7.1.6819.0&wp=MBI_SSL&wreply=${shareUrl} %252523.Y2oC4STQd28.skype%2526lang%253Den%2526flow_id%253D636a02e1aa2f100b%2526source%253DAddThis&lc=1033&id=293290&mkt=en-US&psi=skype&lw=1&cobrandid=2befc4b5-19e3-46e8-8347-77317a16a5a5&client_flight=ReservedFlight33%2CReservedFlight67`
                          : () => error(t("error"))
                      }
                      target="_blank"
                      className="social-modal-ct-icons-diamond-wrap skype"
                    >
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_10234_3053)">
                          <path
                            d="M15.9059 25.5222C10.6128 25.5222 8.1944 22.8258 8.1944 20.8481C8.19368 20.3763 8.38731 19.925 8.72974 19.6005C9.07216 19.2759 9.53315 19.1067 10.0042 19.1327C12.2705 19.1327 11.6777 22.532 15.9059 22.532C18.0672 22.532 19.3367 21.231 19.3367 20.0087C19.3367 19.2743 18.917 18.435 17.4901 18.0992L12.7688 16.9084C8.97604 15.9432 8.31505 13.8343 8.31505 11.8776C8.31505 7.81727 12.0292 6.34842 15.5649 6.34842C18.8226 6.34842 22.6941 8.14776 22.6941 10.5819C22.6941 11.631 21.818 12.1924 20.8003 12.1924C18.8646 12.1924 19.1898 9.47498 15.2973 9.47498C13.3616 9.47498 12.3439 10.3825 12.3439 11.652C12.3439 12.9215 13.8495 13.3517 15.1714 13.6402L18.6547 14.4271C22.4737 15.2874 23.4914 17.5274 23.4914 19.673C23.4914 22.9727 20.9367 25.5222 15.9006 25.5222M30.521 18.5399C30.6722 17.6738 30.7476 16.7962 30.7465 15.9169C30.765 11.5005 28.8245 7.3031 25.448 4.45625C22.0714 1.6094 17.6065 0.4061 13.2567 1.17071C11.9197 0.400945 10.4034 -0.0025715 8.86063 0.000876404C5.69399 0.0202207 2.77511 1.71737 1.1918 4.45983C-0.391511 7.20229 -0.401754 10.5787 1.16489 13.3307C0.290714 18.134 1.82201 23.0612 5.26484 26.5228C8.70766 29.9845 13.6264 31.5426 18.4344 30.6946C19.7697 31.4638 21.2842 31.8673 22.8252 31.8645C25.9902 31.8441 28.9073 30.1477 30.4903 27.4069C32.0733 24.6661 32.0849 21.2916 30.521 18.5399Z"
                            fill="#0078D7"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_10234_3053">
                            <rect
                              width="32"
                              height="32"
                              fill="white"
                              transform="translate(0 0.000854492)"
                            />
                          </clipPath>
                        </defs>
                      </svg>

                      <label className="social-modal-ct-icons-diamond-wrap-label">
                        {t("skype")}
                      </label>
                    </Link>
                  </div>
                ) : (
                  <div className="spinner-border-wrap">
                    <div className="spinner-border" role="status"></div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default NewSocialModal;
